// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d02030ec","453":"63baf1ca","455":"0ebe20fd","977":"3780a271"}[chunkId] + ".chunk.js";
};